import {KlineChannel} from './KlineChannel';

export class DataService {
  private cache: Map<string, KlineChannel>;

  constructor() {
    this.cache = new Map();
  }

  /**
   *
   * @param symbol
   * @param resolution tradingview 内部格式: 1, 3, 60, D, 1D, W, 1W, M, 1M 等
   * @param tradeType
   */
  subscribe(symbol: string, resolution: number, tradeType: string): void {
    const uid = symbol + '_' + resolution;
    if (this.cache.has(uid)) {
      return;
    }

    // 实际周期 转为秒
    const period = resolution * 60;
    const cacheItem = new KlineChannel(symbol, resolution, period, tradeType);
    this.cache.set(uid, cacheItem);
    cacheItem.start();
  }

  unsubscribe(symbol: string, resolution: number, shouldNotUnsubscribe: boolean) {
    const uid = symbol + '_' + resolution;
    if (this.cache.has(uid)) {
      this.cache.get(uid).dispose(shouldNotUnsubscribe);
      this.cache.delete(uid);
    }
  }

  clear() {
    this.cache.clear();
  }
}
